import { render } from "./StatusCurrentCard.vue?vue&type=template&id=a6f9a96a&ts=true"
import script from "./StatusCurrentCard.vue?vue&type=script&lang=ts"
export * from "./StatusCurrentCard.vue?vue&type=script&lang=ts"

import "./StatusCurrentCard.vue?vue&type=style&index=0&id=a6f9a96a&lang=css"

import exportComponent from "/home/runner/work/onecbm-front/onecbm-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/equipment-details/StatusCurrentCard.vue"]])

import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCarousel from 'quasar/src/components/carousel/QCarousel.js';
import QCarouselSlide from 'quasar/src/components/carousel/QCarouselSlide.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QSeparator,QIcon,QCarousel,QCarouselSlide,QBtn});
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a6f9a96a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a6f9a96a', __exports__)) {
    console.log('reload')
    api.reload('a6f9a96a', __exports__)
  }
  
  module.hot.accept("./StatusCurrentCard.vue?vue&type=template&id=a6f9a96a&ts=true", () => {
    console.log('re-render')
    api.rerender('a6f9a96a', render)
  })

}


export default __exports__